import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/hm',
    name: 'HealthMonitoring',
    component: () => import('../views/HealthMonitoring/HealthMonitoring.vue')
  },
  {
    path: '/eh',
    name: 'ElderlyHome',
    component: () => import('../views/elderlyHome/elderlyHome.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
